import {blankString, objectifyArr} from "../../codeFunctions";

export default {
  namespaced: true,
  state() {
    return {
      showTaskChat: false,
    }
  },
  mutations: {
    // setMailConfig(state, payload) {
    //     state.mailConfig = payload
    // },
  },
  actions: {
    // setUserInfo(context, payload) {context.commit('setUserInfo', payload)},

  },
  getters: {
    showAi(state, getters, rootState) {
      return rootState.userInfo?.userInfo?.userID === 1
    },
    showAiChat(state, getters, rootState) {
      return rootState.userInfo?.userInfo?.chatModels.length
    }
  }
}
